module.exports = __webpack_public_path__ + "static/media/piggy-night.dbfe4ab9.png";